export default __webpack_public_path__ + "ffff61599d6452070a3deffb674d8643.svg";